import { render, staticRenderFns } from "./puContRebateAction.vue?vue&type=template&id=2531a407&scoped=true"
import script from "./puContRebateAction.vue?vue&type=script&lang=js"
export * from "./puContRebateAction.vue?vue&type=script&lang=js"
import style0 from "./puContRebateAction.vue?vue&type=style&index=0&id=2531a407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2531a407",
  null
  
)

export default component.exports